import React from 'react';

export default function VerticalSeperator(props) {
  return (
    <span className={`text-muted p-l-xxs p-r-xxs ${props.className}`} >|</span>
  )
}